window.InifECMobileApp.factory("$PreviousState", ['$state', '$rootScope', '$ngModal',
    function($state, $rootScope, $ngModal) {

    var _factory = {};
    var previousList = [];

    // --------------------------------
    // 取得上一頁
    // --------------------------------
    var getLastState = function() {

        while(true) {

            if(previousList == undefined || previousList.length == 0) {
                return undefined;
            }

            var last = previousList.pop();

            // 相同頁面則跳過
            if(JSON.stringify(_factory.currentState) == JSON.stringify(last)) {
                continue;
            }

            switch(last.name) {
                // 全域黑名單
                case window.STATES.PAYMENT_RESULT:
                case window.STATES.PAYMENT_SINOPACCREDITCARD:
                case window.STATES.PAYMENT_POINT:
                case window.STATES.PAYMENT_SINOPACATM:
                case window.STATES.PAYMENT_OUTWARDREMITTANCE:
                case window.STATES.PAYMENT_SPGATEWAYCVS:
                case window.STATES.PAYMENT_MONTHLY:
                case window.STATES.EXTRAFEE_PAYMENT_RESULT:
                case window.STATES.EXTRAFEE_PAYMENT_SINOPACATM:
                case window.STATES.EXTRAFEE_PAYMENT_SINOPACCREDITCARD:
                case window.STATES.EXTRAFEE_PAYMENT_POINT:
                case window.STATES.EXTRAFEE_PAYMENT_OUTWARDREMITTANCE:
                case window.STATES.EXTRAFEE_PAYMENT_SPGATEWAYCVS:
                case window.STATES.EXTRAFEE_PAYMENT_MONTHLY:
                case window.STATES.MAIL_IDENTIFY:
                case window.STATES.RESET_PASSWORD:
                case window.STATES.CHANGE_EMAIL:
                case window.STATES.NATIVE_LOGIN_MODAL:
                case window.STATES.BUSINESSMEMBER_MAIL_IDENTIFY:
                    break;
                default:
                    return last;
            }
        }        
    }

    // --------------------------------
    // 取得商品列表的上一頁
    // --------------------------------
    var getProductListPrevious = function() {

        while(true) {
            var last = getLastState();

            if(last == undefined) {

                var backState = {
                    name: window.STATES.HOME,
                    params: {}
                };

                return backState;
            }

            switch(last.name) {
                case window.STATES.PRODUCT_LIST:
                case window.STATES.PRODUCT:
                case window.STATES.COMPLEX_PDT:
                    break;
                default:
                    return last;
            }
        }
    }

    // --------------------------------
    // 取得商品頁面的上一頁
    // --------------------------------
    var getProductPrevious = function(pdtClass) {

        while(true) {

            var last = getLastState();

            if(last == undefined) {

                var backState = {
                    name: window.STATES.PRODUCT_LIST,
                    params: {
                        class: pdtClass,
                    }
                };

                if(pdtClass == undefined) {
                    backState.name = window.STATES.HOME;
                }

                return backState;
            }

            switch(last.name) {
                case window.STATES.PRODUCT:
                case window.STATES.COMPLEX_PDT:
                    break;
                default:
                    return last;
            }
        }
    }

    // --------------------------------
    // 取得購物車的上一頁
    // --------------------------------
    var getCartPrevious = function() {

        while(true) {

            var last = getLastState();

            if(last == undefined) {

                var backState = {
                    name: window.STATES.HOME,
                    params: {}
                };

                return backState;
            }

            switch(last.name) {
                case window.STATES.CART:
                    break;
                default:
                    return last;
            }
        }
    }

    // --------------------------------
    // 取得訂單的上一頁
    // --------------------------------
    var getOrderPrevious = function() {

        while(true) {

            var last = getLastState();

            if(last == undefined) {

                var backState = {
                    name: window.STATES.ORDER_LIST_ALL,
                    params: {}
                };

                return backState;
            }

            switch(last.name) {
                case window.STATES.CART:
                case window.STATES.ORDER:
                    break;
                default:
                    return last;
            }
        }
    }

    // --------------------------------
    // 取得FAQ的上一頁
    // --------------------------------
    var getFAQPrevious = function() {

        while(true) {

            var last = getLastState();

            if(last == undefined) {

                var backState = {
                    name: window.STATES.FAQ,
                    params: {}
                };

                return backState;
            }

            switch(last.name) {
                case window.STATES.FAQ_CONTENT:
                    break;
                default:
                    return last;
            }
        }
    }

    // --------------------------------
    // 取得通知訊息的上一頁
    // --------------------------------
    var getSystemMessagePrevious = function() {

        while(true) {

            var last = getLastState();

            if(last == undefined) {

                var backState = {
                    name: window.STATES.OTHER,
                    params: {}
                };

                return backState;
            }

            switch(last.name) {
                case window.STATES.SYSTEM_MESSAGE:
                    break;
                default:
                    return last;
            }
        }
    }

    // --------------------------------
    // 取得訂購流程的上一頁
    // --------------------------------
    var getBeginnersGuidePrevious = function() {

        while(true) {

            var last = getLastState();

            if(last == undefined) {

                var backState = {
                    name: window.STATES.HOME,
                    params: {}
                };

                return backState;
            }

            switch(last.name) {
                case window.STATES.BEGINNERS_GUIDE:
                    break;
                default:
                    return last;
            }
        }
    }

    // --------------------------------
    // 取得企業用戶申請的上一頁
    // --------------------------------
    var getEnterpriseSignupPrevious = function() {

        while(true) {
            var last = getLastState();

            if(last == undefined) {

                var backState = {
                    name: window.STATES.HOME,
                    params: {}
                };

                return backState;
            }

            switch(last.name) {
                case window.STATES.ENTERPRISE_SIGNUP:
                    break;
                default:
                    return last;
            }
        }
    }

    // --------------------------------
    // 將目前頁面記錄下來（入口為mobileapp.js
    // --------------------------------
    var addStataToList = function(state){

        previousList.push(state);

        _factory.currentState = state;

        var msg = {
            type: 'stateChanged',
            name: state.name,
            params: state.params,
        }

        msg = JSON.stringify(msg);

        // post state change message
        if( window.WebViewBridge !== undefined && window.WebViewBridge.postMessage){
            window.WebViewBridge.postMessage(msg);
        } else if( window.WebViewBridge !== undefined && window.WebViewBridge.send){
            window.WebViewBridge.send(msg);
        }
        window.postMessage(msg, '*');
    }

    var goBack = function(state) {

        $state.go(state.name, state.params);
    }

    var initWebViewBridge = function(webViewBridge) {

        webViewBridge.onMessage = function(msg) {
            var cmd = JSON.parse(msg);

            console.log(cmd);

            if(cmd.command){
                switch (cmd.command){
                    case 'goBack':
                        goBack(cmd.state);
                        break;
                    case 'useNativeLoginModal':
                        $rootScope.useNativeLoginModal = true;
                        break;
                    case 'loginSuccess':
                        $ngModal.closeModal('login-modal');
                        $ngModal.closeModal('register-modal');
                        $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                            title: '登入成功',
                        });
                        $rootScope.$broadcast("LOGIN_SUCCESS");
                        goBack(cmd.state);
                        break;
                    case 'loginCanceled':
                    case 'loginFailed':
                        $ngModal.closeModal('login-modal');
                        $ngModal.closeModal('register-modal');
                        goBack(cmd.state);
                        break;
                    case 'paymentFinished':
                        var resulturl = cmd.resulturl;
                        var appresult = 'app_creditcard_result.html?';
                        var index = resulturl.indexOf(appresult);

                        if(index == -1) {
                            return 
                        }

                        var query = resulturl.substr(index + appresult.length);
                        var params = query.split("/");

                        var id = params[0];
                        var errorcode = params[1];
                        var errordesc = params[2];
                        var prev_id = id.substring(0,1);

                        // 判斷是否為補收款
                        if(prev_id.toUpperCase() == 'E') {
                            $state.go(window.STATES.EXTRAFEE_PAYMENT_RESULT, {
                                extrafeeid: id,
                                errorcode: errorcode,
                                errordesc: errordesc,
                            });
                        } else {
                            $state.go(window.STATES.PAYMENT_RESULT, {
                                orderid: id,
                                errorcode: errorcode,
                                errordesc: errordesc,
                            });
                        }

                        break;
                    case 'cancelPayment':

                        if(cmd.extrafeeid) {
                            $state.go(window.STATES.EXTRAFEE_PAYMENT_RESULT, {
                                extrafeeid: cmd.extrafeeid,
                                errorcode: "取消付款",
                                errordesc: "訂單已取消付款",
                            });
                        } else {
                            $state.go(window.STATES.PAYMENT_RESULT, {
                                orderid: cmd.orderid,
                                errorcode: "取消付款",
                                errordesc: "訂單已取消付款",
                            });
                        }
                        
                        break;
                }
            }
        }

        initSuccess(webViewBridge);
    }

    var initSuccess = function(webViewBridge) {

        if(webViewBridge !== undefined && webViewBridge.postMessage) {

            var msg = {
                type: 'initWebView',
            }

            msg = JSON.stringify(msg);

            webViewBridge.postMessage(msg);
        } else if(webViewBridge !== undefined && webViewBridge.send) {

            var msg = {
                type: 'initWebView',
            }

            msg = JSON.stringify(msg);

            webViewBridge.send(msg);
        }
    }

    var init = function() {

        if (window.WebViewBridge) {
            initWebViewBridge(window.WebViewBridge);
            return;
        }

        function handler() {
            //remove the handler from listener since we don't need it anymore
            document.removeEventListener('WebViewBridge', handler, false);
            //pass the WebViewBridge object to the callback
            initWebViewBridge(window.WebViewBridge);
        }

        //if WebViewBridge doesn't exist in global scope attach itself to document
        //event system. Once the code is being injected by extension, the handler will
        //be called.
        document.addEventListener('WebViewBridge', handler, false);
    }

    /*==========================
        Members
    ==========================*/
    _factory.currentState;

    /*==========================
        Methods
    ==========================*/
    _factory.getLastState = getLastState;
    _factory.getProductListPrevious = getProductListPrevious; 
    _factory.getProductPrevious = getProductPrevious;
    _factory.getCartPrevious = getCartPrevious;
    _factory.getOrderPrevious = getOrderPrevious;
    _factory.getFAQPrevious = getFAQPrevious;
    _factory.getSystemMessagePrevious = getSystemMessagePrevious;
    _factory.getBeginnersGuidePrevious = getBeginnersGuidePrevious;
    _factory.getEnterpriseSignupPrevious = getEnterpriseSignupPrevious;
    _factory.addStataToList = addStataToList;
    _factory.goBack = goBack;

    /*==========================
        Init
    ==========================*/
    init();

    return _factory;

}]);